import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { Container } from "pixi.js";
import { NotificationLayerProvider } from "by/gamefactory/cityversetycoon/composition/providers/NotificationLayerProvider";
import { inject, injectable } from "@launchtray/tsyringe-async";
import { FadeScreen } from "../../game/components/FadeScreen";
import { LoaderAnimation } from "./animations/LoaderAnimation";
import { CommonResourcesPackage } from "../resources/CommonResourcesPackage";
import { FixedSizeContainer } from "./FixedSizeContainer";

@injectable()
export class AsyncOperationNotification extends Container {
    private readonly notificationLayerProvider: NotificationLayerProvider;

    private uiContainer: Container;
    private loaderAnimation: LoaderAnimation;

    public constructor(
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        notificationLayerProvider: NotificationLayerProvider,
        commonResourcePackage: CommonResourcesPackage
    ) {
        super();
        this.notificationLayerProvider = notificationLayerProvider;
        const width = canvasScaler.referenceWidth;
        const height = canvasScaler.referenceHeight;
        this.uiContainer = new FixedSizeContainer(width, height);
        this.addChild(this.uiContainer);
        const fader = new FadeScreen(0.1, 0.0, 0.7, width, height);
        fader.position.set(0, 0);
        fader.fadeIn();
        this.uiContainer.addChild(fader);
        this.loaderAnimation = new LoaderAnimation(
            [
                commonResourcePackage.assets_common_ui_loading_coin_png,
                commonResourcePackage.assets_common_ui_loading_crawn_png,
                commonResourcePackage.assets_common_ui_loading_star_png
            ]
        );
        this.loaderAnimation.position.set((width - this.loaderAnimation.predictedWidth * this.loaderAnimation.scale.x) * 0.5, height * 0.5);
        this.uiContainer.addChild(this.loaderAnimation);
        this.notificationLayerProvider.notificationLayer.addChild(this);
        this.hide();
    }

    public show(): void {
        this.loaderAnimation.play();
        this.uiContainer.alpha = 1;
        this.eventMode = "dynamic";
    }

    public hide(): void {
        this.loaderAnimation.stop();
        this.uiContainer.alpha = 0;
        this.eventMode = "none";
    }

    public async autoShowHide<T>(operation: Promise<T>): Promise<T> {
        this.show();
        try {
            return await operation;
        }
        catch (e: unknown) {
            throw e;
        }
        finally {
            this.hide();
        }
    }
}
